require('./lte-interface-2.scss');

import DemandeActions from '../../../../actions/demande.actions';

import { STEPS } from '../../../../utils/routes.util';

export default class LteInterface2Component {
  constructor() {
    this.controller = LteInterface2Controller;
    this.template = require('./lte-interface-2.html');
  }
}

// @ngInject
class LteInterface2Controller {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.LTE_INTERFACE_2));

    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.lteInterface2 ? state.demande.data.lteInterface2.asMutable({deep: true}) : this.data,
          typePersonne: state.demande.data.typePersonne
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
    this.data = {};
  }
  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateLteInterface2(this.data, true));
  }

  nextStep() {
    this.$ngRedux.dispatch(DemandeActions.updateLteInterface2(this.data));
  }

}



// WEBPACK FOOTER //
// ./src/modules/lte/components/lte-interface-2/lte-interface-2.component.js